import React from "react";
import { useState, useEffect } from "react";
import { FxmsData } from "../fxms/datas/FxData";
import { SensorCheck } from "./SensorCheck";
import { SensorTable } from "./SensorTable";
import { ComplexEng } from "./ComplexEng";
import { NavLink } from "react-router-dom";
import "./../css/VUP_dash.css";

export const ComplexSensor = (props) => {
  const inloClCd = "COMPLEX";
  const complexInloNo = props.complexInloNo;

  const tmpInloList = FxmsData.getDatas("inlo", {
    inloClCd: inloClCd,
    complexInloNo: complexInloNo,
  });


  return (
    <>
      <div className="grayBox line1">
        <div
          style={{
            fontSize: "28px",
            margin: 0,
            paddingBottom: "10px",
            verticalAlign: "top",
            lineHeight: "30px",
            textShadow: "0 4px 8px black",
          }}
        >
          <NavLink to={"/comp-vup-complex-dash/" + complexInloNo}>
            {tmpInloList.map((complex) => complex.inloName)}
          </NavLink>
        </div>
        <div>
          <SensorCheck complexInloNo={complexInloNo}></SensorCheck>
        </div>
        <div>
          <SensorTable complexInloNo={complexInloNo} />
        </div>
      </div>
      <div className="grayBox line3">
        <div>
          <ComplexEng complexInloNo={complexInloNo} tmpInloList={tmpInloList}/>
        </div>
      </div>
    </>
  );
};